import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { BaseFormService, ButtonLoader } from '../../../../../core';
import { Lead } from '../../lead';
import { QUERY_PARAM_LEAD_NEGOCIO } from '../../lead-consts';
import { LeadFormComponent } from '../form';
import { LeadFormInfoComponent } from '../form-info';

@Component({
    selector: 'sgt-lead-form-container',
    templateUrl: './lead-form-container.component.html',
    styleUrls: ['./lead-form-container.component.less']
})
export class LeadFormContainerComponent implements OnInit {
    /** Se o form é somente leitura */
    @Input() readonly = false;
    /** Se deve obter o ID do lead via query param */
    @Input() isGetIDParam = true;
    /** Se deve exibir os botões de opções */
    @Input() isShowOptions = true;
    /** Se o form deve ser exibido em tamanho pequeno */
    @Input() isMini = false;
    /** Se deve exibir o usuário responsável */
    @Input() isShowUsuarioResponsavel = true;
    /** Se deve exibir a temperatura */
    @Input() isShowTemperatura = true;

    /** Evento após cancelar o cadastro do lead */
    @Output() afterCancel = new EventEmitter<void>();

    @ViewChild('leadForm') leadForm: LeadFormComponent;
    @ViewChild('leadFormInfo') leadFormInfo: LeadFormInfoComponent;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private baseFormService: BaseFormService) { }

    ngOnInit() {
        if (this.isGetIDParam) {
            this.baseFormService.getIdParam(this.activatedRoute).then(id => {
                if (this.readonly) {
                    this.leadFormInfo?.load(id);
                } else {
                    if (!id) {
                        this.leadForm?.preInsert();
                    } else {
                        this.leadForm?.edit(id);
                    }
                }
            });
        }
    }

    preInsert(nomeLead: string = null) {
        this.leadForm?.preInsert(nomeLead);
    }

    edit(idLead: number) {
        this.leadForm?.edit(idLead);
    }

    load(idLead: number): Promise<void> {
        return new Promise<void>(async (resolve, reject) => {
            try {
                if (this.readonly) {
                    await this.leadFormInfo?.load(idLead);
                } else {
                    await this.leadForm?.load(idLead);
                }

                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }

    save(): Promise<Lead> {
        return new Promise<Lead>(async (resolve, reject) => {
            try {
                const lead = await this.leadForm?.save();
                resolve(lead);
            } catch (error) {
                reject(error);
            }
        });
    }

    get entity(): Lead {
        return this.leadForm?.entity ?? null;
    }

    setNomeLead(nome: string) {
        this.leadForm.entity.nome = nome;
    }

    get valid(): boolean {
        if (this.readonly) {
            return true;
        }

        return this.leadForm?.form?.valid ?? false;
    }

    get invalid(): boolean {
        if (this.readonly) {
            return false;
        }

        return this.leadForm?.form?.invalid ?? false;
    }

    isValid(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if (this.readonly) {
                resolve(true);
                return;
            }

            resolve(this.leadForm?.isValid());
        })
    }

    /** Se está realizando o pré-insert */
    get isShowPreInsertForm(): boolean {
        return this.leadForm?.isShowPreInsertForm;
    }

    /** Executa a chamada da confirmação do pré-insert */
    execConfirmPreInsert() {
        this.leadForm?.execConfirmPreInsert();
    }


    async saveClick() {
        const btnSave = new ButtonLoader('#btnSave');
        try {
            btnSave.loading('Salvando');

            await this.leadForm?.save();
            this.afterSave();
            btnSave.reset();
        } catch (error) {
            btnSave.reset();
        }
    }

    afterSave() {
        if (!this.leadForm?.editMode) { // Se tiver inserido um novo lead
            this.afterSaveInsert();
        } else { // Se estiver editando um lead
            this.afterSaveEdit();
        }
    }

    private afterSaveInsert() {
        // Adicionando query param com o ID do lead inserido para informar que deve criar um negócio para este lead
        this.router.navigate(['../'], {relativeTo: this.activatedRoute, queryParams: {[QUERY_PARAM_LEAD_NEGOCIO]: this.leadForm?.entity.id}});
    }

    private afterSaveEdit() {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
        this.afterCancel.emit();
    }
}
